import { call, put, takeLatest } from "redux-saga/effects";
import fetchAPI, { ApiResponse } from "../../../utils/api";
import loginPageSlice from "../../login-page/store/slice";
import statusSlice, { Status } from "./slice";

type StatusResponse = ApiResponse<{ data: Status[] }>;

function* statusSaga() {
  yield takeLatest(loginPageSlice.actions.setLoggedIn, handleFetch);
}

function* handleFetch() {
  const response: StatusResponse = yield call(fetchAPI, "/booking-statuses");

  if (response && response.data) {
    yield put(statusSlice.actions.setData(response.data));
  }

  yield put(statusSlice.actions.setIsLoading(false));
}

export default statusSaga;
